import { array, boolean, nullable, number, object, string } from "valibot";

export const SendTransacInputSchema = object({
  travel: object({
    id: number(),
    title: string(),
    brandTitle: nullable(string()),
    travelTypeId: string(),
    destinations: array(string()),
    themes: array(string()),
  }),
  atCampaign: nullable(string()),
});

export const SendTransacOutputSchema = object({
  success: boolean(),
});

export type SendTransacInputSchema = typeof SendTransacInputSchema;
export type SendTransacOutputSchema = typeof SendTransacOutputSchema;
